import { defineStore } from 'pinia'
import Api from "@/services/Api";
import { useMenuStore } from '@/stores/menu'

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
		is_loggedin: false,
		user: {},
    session_check: -1,
    seenPriceChangeIds: null,
    seenOfferChangeIds: null,
    seenIntakeSyncIds: null,
  }),
  getters: {
  }, 
  actions: {
    async get_user_notifications(user){
      let newcomers = []
      await Api(true) .post("/user/get/notifications", { user })
      .then(res => {
        Object.keys(res.data).map((key) => {
          if(!useMenuStore().notifications_list[key]){useMenuStore().notifications_list[key] = []}
          useMenuStore().notifications_list[key] = res.data[key]
        })
        if (!Object.prototype.hasOwnProperty.call(res.data || {}, "price_change")) {
          useMenuStore().notifications_list.price_change = []
        }
        if (!Object.prototype.hasOwnProperty.call(res.data || {}, "offer_change")) {
          useMenuStore().notifications_list.offer_change = []
        }
        if (!Object.prototype.hasOwnProperty.call(res.data || {}, "stock_intake")) {
          useMenuStore().notifications_list.stock_intake = []
        }
        localStorage.notifications_list = JSON.stringify(useMenuStore().notifications_list);
        const incoming = Array.isArray(res.data?.price_change) ? res.data.price_change : []
        const incomingIds = incoming.map((n) => n.batch_id).filter(Boolean)
        const isFirst = this.seenPriceChangeIds === null
        const prev = new Set(this.seenPriceChangeIds || [])
        newcomers = isFirst ? [] : incoming.filter((n) => n.batch_id && !prev.has(n.batch_id))
        this.seenPriceChangeIds = incomingIds

        const incomingOffers = Array.isArray(res.data?.offer_change) ? res.data.offer_change : []
        const incomingOfferIds = incomingOffers.map((n) => n.guid).filter(Boolean)
        const isFirstOffer = this.seenOfferChangeIds === null
        const prevOffers = new Set(this.seenOfferChangeIds || [])
        const offerNewcomers = isFirstOffer ? [] : incomingOffers.filter((n) => n.guid && !prevOffers.has(n.guid))
        this.seenOfferChangeIds = incomingOfferIds
        newcomers = newcomers.concat(offerNewcomers)

        const incomingIntake = Array.isArray(res.data?.stock_intake) ? res.data.stock_intake : []
        const incomingIntakeIds = incomingIntake.map((n) => n.sync_id).filter(Boolean)
        const isFirstIntake = this.seenIntakeSyncIds === null
        const prevIntake = new Set(this.seenIntakeSyncIds || [])
        const intakeNewcomers = isFirstIntake ? [] : incomingIntake.filter((n) => n.sync_id && !prevIntake.has(n.sync_id))
        this.seenIntakeSyncIds = incomingIntakeIds
        newcomers = newcomers.concat(intakeNewcomers)
      })
      return { newcomers }
    }
  }
})
